import React from 'react';
import DataLoader from "./DataLoader";

const LoaderContainer = ({loading, label, children}) => {
    if (loading) {
        return <DataLoader label={label}/>;
    }

    return children;
};

export default LoaderContainer;
